import * as React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n-config';
import App from "./components/App";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { TextSizeProvider } from "./contexts/TextSizeContext";
import { PostHogProvider } from "./components/PostHogProvider";
import "./taskpane.css";
/* global document, Office, module, require */

let root = null;
let currentContainer = null;
let containerObserver = null;

function render(AppComponent) {
  const container = document.getElementById("container");
  if (!container) return;

  // If container changed (e.g., HMR replaced DOM), recreate the root
  if (!root || currentContainer !== container) {
    if (root && typeof root.unmount === "function") {
      root.unmount();
    }
    root = createRoot(container);
    currentContainer = container;
  }

  root.render(
    <I18nextProvider i18n={i18n}>
      <PostHogProvider>
        <AuthProvider>
          <LanguageProvider>
            <TextSizeProvider>
              <AppComponent />
            </TextSizeProvider>
          </LanguageProvider>
        </AuthProvider>
      </PostHogProvider>
    </I18nextProvider>
  );
}

/* Render application after Office initializes */
Office.onReady(() => {
  render(App);

  // Observe for container replacement (e.g., Outlook pin/unpin or host DOM swaps)
  try {
    if (window.MutationObserver) {
      containerObserver = new MutationObserver(() => {
        const detected = document.getElementById("container");
        if (detected && detected !== currentContainer) {
          render(App);
        }
      });
      containerObserver.observe(document.body, { childList: true, subtree: true });
    }
  } catch {}
});

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });

  module.hot.dispose(() => {
    if (containerObserver) {
      try { containerObserver.disconnect(); } catch {}
      containerObserver = null;
    }
    if (root && typeof root.unmount === "function") {
      root.unmount();
    }
    root = null;
    currentContainer = null;
  });
}
